import React from 'react'

import '../scss/variables.scss'
import '../scss/reset.scss'
import './Progetto.scss'
import NavbarLogo from '../components/NavbarLogo/NavbarLogo'
import Footer from '../components/Footer/Footer'
import Sidemenu from '../components/Sidemenu/Sidemenu'

/* ===IMGS=== */
import Image3 from '../assets/images/Image_3.svg'
import Image4 from '../assets/images/Image_4.svg'

function Progetto() {

    return (
        <>
            <Sidemenu path1="/" name1="Home" path2="/chi-siamo" name2="Chi Siamo" path3="/supportaci" name3="Supportaci" path4="/community" name4="Community"/>
            <NavbarLogo />
            <main id="progetto">
                <h1>Il Progetto</h1>
                <div className="supportProject">
                    <p>Nato nel <b>2021</b>, durante un periodo difficile, 
                   <b> FADY</b> mette a disposizione un nuovo metodo 
                    di studio in <b>compagnia</b>, per aiutare tutti gli 
                    studenti distanti.</p>

                    <img src={Image3} className="Image3" alt="FadyProject1" />
                    <img src={Image4} className="Image4" alt="FadyProject2" />

                    <p>Entrando in <b>FADY</b> potrai trovare un sacco di <b>stanze</b>, 
                        dedicate ad argomenti e materie diverse. 
                        Quando vuoi, puoi cliccare su una delle stanze, 
                        ed <b>unirti</b> ad essa.</p>

                </div>
            </main>
            <Footer />
        </>
    )
}

export default Progetto
